import React from 'react'

const BreadcrumbItemActive = ({ children }) => (
  <li className='breadcrumb-item active' aria-current='page'>
    {children}
  </li>
)

export default BreadcrumbItemActive
